import React from "react";
import { RaisedButton } from "material-ui";
import BaseOverlay from "./base.jsx";
import AccountCreation from "../partials/account-creation.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonStore from "../../stores/PersonStore";
import TicketActions from "../../actions/TicketActions";
import TicketStore from "../../stores/TicketStore";

@connectToStores
class AcceptTicketTransferOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.cancel = this.cancel.bind(this);
    this.accept = this.accept.bind(this);
    this.isSundance = this.isSundance.bind(this);
  }

  static get contextTypes() {
    return {
      tenant: React.PropTypes.object,
      router: React.PropTypes.object.isRequired
    };
  }

  static getStores() {
    return [TicketStore, PersonStore];
  }

  static getPropsFromStores() {
    let store = TicketStore.getState();
    store.isLoggedIn = PersonStore.getState().isLoggedIn;
    return store;
  }

  cancel() {
    if (this.isSundance()) {
      window.location.href = "https://festival.sundance.org";
    }
    else {
      this.context.router.push(`/welcome`);
    }
  }

  accept() {
    TicketActions.acceptTicketTransfer(
      this.props.location.query.transfer,
      this.props.location.query.token
    );
  }

  isSundance() {
    return !!this.context.tenant.sundance_login;
  }

  componentWillMount() {
    TicketActions.resetAcceptTicketTransfer.defer();
  }

  componentWillReceiveProps(props) {
    if (props.transferComplete) {
      this.context.router.push(`/tickets`);
    }
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  render() {
    return (
      <BaseOverlay>
        <div style={{ textAlign: "center", fontSize: "11pt" }}>
          <h3>Accept ticket transfer</h3>
          {this.props.isLoggedIn ? (
            <div>
              <p>To accept the ticket transfer, just click the button below.</p>
              <div style={{ marginTop: 10 }}>
                <RaisedButton
                  label={`Accept ticket transfer`}
                  primary={true}
                  onClick={this.accept}
                />
                <RaisedButton
                  label="Cancel"
                  style={{ marginLeft: 7 }}
                  onClick={this.cancel}
                />
              </div>
            </div>
          ) : (
            <AccountCreation actionVerb="accept this transfer" />
          )}
        </div>
      </BaseOverlay>
    );
  }
}

export default AcceptTicketTransferOverlay;



// WEBPACK FOOTER //
// ./src/app/components/overlays/accept-ticket-transfer.jsx